import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

const formatRating = (rating) =>
  typeof rating === 'number' ? rating.toFixed(1).replace('.', ',') : '0,0';

const ReviewsSummary = ({ averageStars = 0, className }) => (
  <div
    className={twMerge('flex items-center gap-x-2 py-3', className)}
    data-testid="reviews-summary"
  >
    <Icon
      aria-hidden="true"
      className="text-communication-300 dark:text-communication-300"
      name="rating-star-filled"
      size="size1"
    />
    <Text as="span" size="size1" bold>
      {formatRating(averageStars)}
    </Text>
    <Text as="span" className="text-neutral-low-300" size="size3">
      Nota do produto pela comunidade
    </Text>
  </div>
);

ReviewsSummary.propTypes = {
  /**
   * Average stars rating for the alias, eg. 4.5
   */
  averageStars: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default ReviewsSummary;
